import { render, staticRenderFns } from "./BaseInputNumberWithButtons.vue?vue&type=template&id=f23301d4&scoped=true&"
import script from "./BaseInputNumberWithButtons.vue?vue&type=script&lang=ts&"
export * from "./BaseInputNumberWithButtons.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputNumberWithButtons.vue?vue&type=style&index=0&id=f23301d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23301d4",
  null
  
)

export default component.exports